import { Grid } from "@material-ui/core";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import GenericButton from "components/Buttons/GenericButton";
import GenericDialog from "components/Dialogs/GenericDialogV2";
import PageTitleHeader from "components/Headers/PageTitleHeader";
import { createCooperativeMember } from "crud/cooperativeMembers.crud";
import { useDataset } from "hooks/useDataset";
import useMessage from "hooks/useMessage";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { DATASET } from "utils/const";
import CooperativeMemberFormFields from "../CooperativeMemberFormFields";
import {
  buildCreateCooperativeMemberFormData,
  getApiErrorMessage,
  invalidateCooperativeMemberQueries,
  openCooperativeMemberConfirmationDialog,
  showCooperativeMemberSuccessDialog,
} from "../cooperativeMember.utils";

const CooperativeMembersModal = ({ openDialog, handleCloseDialog, cooperativeId }) => {
  const dispatch = useDispatch();
  const { showErrorMessage } = useMessage();
  const queryClient = useQueryClient();

  const methods = useForm({
    defaultValues: {},
    shouldFocusError: false,
  });

  const { data: professionalCategoryOptions } = useDataset({ name: DATASET.PROFESSIONAL_CATEGORY });
  const { data: documentTypeOptions } = useDataset({ name: DATASET.COLLECTIVE_EMPLOYEE_DOCUMENT_TYPES });

  const { mutateAsync: createCooperativeMemberAsync, isLoading: isCreating } = useMutation(
    ["createCooperativeMember"],
    (data) => createCooperativeMember(data),
    {
      onSuccess: () => {
        invalidateCooperativeMemberQueries(queryClient);
        showCooperativeMemberSuccessDialog(dispatch, "Membro da Cooperativa criado com sucesso.");
        handleCloseDialog();
      },
      onError: (error) => {
        showErrorMessage(getApiErrorMessage(error, "Ocorreu um erro ao criar o Membro da Cooperativa."));
      },
    },
  );

  const onSubmit = async (data) => {
    const apiFormData = buildCreateCooperativeMemberFormData({
      cooperativeId,
      values: data,
    });

    openCooperativeMemberConfirmationDialog(
      dispatch,
      "Deseja confirmar a criação do novo Membro da Cooperativa?",
      async () => {
        await createCooperativeMemberAsync(apiFormData);
      },
    );
  };

  return (
    <form>
      <GenericDialog open={openDialog} onClose={handleCloseDialog} maxWidth="lg">
        <PageTitleHeader title="Adicionar Membro da Cooperativa" style={{ marginLeft: "-22px" }} />

        <Grid container>
          <CooperativeMemberFormFields
            methods={methods}
            professionalCategoryOptions={professionalCategoryOptions}
            documentTypeOptions={documentTypeOptions}
            showIdentitySectionTitle
            showUploadSection
            uploadFieldsRequired
          />

          <Grid
            item
            xs={12}
            md={12}
            style={{
              gap: "1rem",
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "2rem",
            }}
          >
            <GenericButton
              typeSubmit={false}
              size="medium"
              color="tertiary"
              onClick={handleCloseDialog}
            >
              Cancelar
            </GenericButton>
            <GenericButton
              size="medium"
              color="primary"
              onClick={methods.handleSubmit(onSubmit)}
              loading={isCreating}
            >
              Adicionar Membro da Cooperativa
            </GenericButton>
          </Grid>
        </Grid>
      </GenericDialog>
    </form>
  );
};

export default CooperativeMembersModal;
